import * as IntegrationsActions from "./IntegrationsActions";

export default IntegrationsActions;



// WEBPACK FOOTER //
// ./src/actions/IntegrationsActions/index.js